import { SITE_VARIABLES } from '../../../../common/styles/variables';
import { flexColumnCenter, flexRowCenter } from '../../../../common/styles/flex';

interface StylesObject {
  nextVideoContainerStyle: { [key: string]: any };
  nextVideoStyle: { [key: string]: any };
  thumbnailStyle: { [key: string]: any };
  blurThumbnailStyle: { [key: string]: any };
  thumbnailWrapperStyle: { [key: string]: any };
  playBlurIconStyle: { [key: string]: any };
  closeIconStyle: { hide: { [key: string]: any } } & any;
  durationStyle: { [key: string]: any };
}

const titleFontFamily = SITE_VARIABLES.TEXT_FONT_FAMILY.LATO;
const titleColor = SITE_VARIABLES.COLORS.WHITE;

const nextVideoContainer = {
  ...flexColumnCenter,
  width: '165px',
  height: '128px',
  marginBottom: '4px',
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.TINY,
  backdropFilter: 'blur(3px)',
  webkitBackdropFilter: 'blur(3px)',
  backgroundColor: SITE_VARIABLES.COLORS.BLACK_80_OPACITY,
};

const nextVideo = {
  position: 'relative',
  cursor: 'pointer',
  width: '153px',
  height: '86px',
  margin: '6px 6px 4px 6px',
};

const thumbnailWrapper = {
  ...flexRowCenter,
};

const thumbnail = {
  maxWidth: '153px',
  maxHeight: '86px',
};

const blurThumbnail = {
  position: 'absolute',
  width: '153px',
  height: '37px',
  bottom: '18px',
  backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.71))',
};

const closeIcon = {
  display: 'flex',
  position: 'absolute',
  top: '0px',
  right: '0px',
  width: '20px',
  height: '20px',
};

const playBlurIcon = {
  display: 'block',
  position: 'absolute',
  top: '31px',
  right: '64px',
  width: '24px',
  height: '24px',
};

const duration = {
  position: 'absolute',
  bottom: '22px',
  right: '6px',
  fontFamily: titleFontFamily,
  fontWeight: '400',
  fontSize: '8px',
  color: titleColor,
};

export const getNextVideoStyleObject = (): StylesObject => ({
  nextVideoContainerStyle: {
    ...nextVideoContainer,
  },
  nextVideoStyle: {
    ...nextVideo,
  },
  thumbnailWrapperStyle: {
    ...thumbnailWrapper,
  },
  thumbnailStyle: {
    ...thumbnail,
  },
  blurThumbnailStyle: {
    ...blurThumbnail,
  },
  playBlurIconStyle: {
    ...playBlurIcon,
  },
  closeIconStyle: {
    ...closeIcon,
  },
  durationStyle: {
    ...duration,
  },
});
